// extracted by mini-css-extract-plugin
export default {"body":"FavoritePlants_body__lxS17","contextWrapper":"FavoritePlants_contextWrapper__jScNQ","gridWrapper":"FavoritePlants_gridWrapper__Ugkzr"};